export enum TableBoName {
	ESTIMATIONS = "estimations",
	AGENCIES = "agencies",
	USERS = "users",
}
